import * as React from 'react';

import Typography from '@components/basics/typography';
import GraphTooltip from '@webapp/controllers/analytics/graph-tooltip';
import { Translate } from 'react-localize-redux';
import { DSPId, DSP_MAPPING } from '@services/analytics/types/dsp-ids';

interface EarnedGraphTooltipProps {
  className?: string;
  date: React.ReactNode;
  number: React.ReactNode;
  dsp?: DSPId;
}

const formatEarned = (earned: number) => {
  const value = Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(earned);

  return value;
};

export const EarnedGraphTooltip: React.FC<EarnedGraphTooltipProps> = (
  props
) => {
  return (
    <GraphTooltip>
      <Typography color="white" opacity=".5" weight="700">
        {props.date}
      </Typography>
      <Typography color="white" weight="700">
        {props.dsp ? `${DSP_MAPPING[props.dsp]}: ` : ''}
        {formatEarned(Number(props.number))}{' '}
        <Translate id="ANALYTICS.YOUR_CATALOG.EARNED" />
      </Typography>
    </GraphTooltip>
  );
};

export default EarnedGraphTooltip;
